import type { Error } from '../Error'
import type { Info } from './Info'
import type { OfferDiscount } from './OfferDiscount'
import type { OfferDiscountRequest } from './OfferDiscountRequest'
import type { OfferUnderwriting } from './OfferUnderwriting'
import type { Part } from './Part'

export interface OfferSimple {
  offerId: number
  type: OfferType
  offerType: string
  insurerId: number
}

export interface Offer extends OfferSimple {

  internalCalculationId: string
  insurerName: string
  insurerNameFull: string
  included: boolean
  dateCalculated?: string
  dateChanged: string
  calculationDataChanged: string
  price: number
  priceFrequency: number
  paymentFrequencyId?: number
  priceFrequencyText: string
  insuranceVariantId: number
  stars?: QuoteRating
  parts: Part[]
  errors: Error[]
  warnings: Error[]
  infos: Info[]
  underwriting?: OfferUnderwriting
  discounts: OfferDiscount[]
  discountRequest?: OfferDiscountRequest
  print?: boolean
  state: CalculationStatus
  clonedFromParamsId?: number
}

export type QuoteRating = 0 | 1 | 2 | 3 | undefined


export const CalculationStatus = {
  Calculation: 0,
  Offer: 1, // confirmed
  WaitingForSubscription: 2,
  Subscribed: 3,
  SubscribedWithConditions: 4,
  Policy: 5
} as const;

export type CalculationStatus = typeof CalculationStatus[keyof typeof CalculationStatus];

export const OfferType = {
  Standard: 2, // confirmed
  KoopSalon: 3,
  ZnacnovePojisteniSubaru: 4,
  ZnacnovePojisteniMazda: 5,
  ZnackovePojisteniKia: 6
} as const;

export type OfferType = typeof OfferType[keyof typeof OfferType];

export const InsuranceParamsTypes: [OfferType, string, string, string, string][] = [
  [OfferType.Standard, 'Standartní', "SP", "primary.50", "primary.500"],
  [OfferType.KoopSalon, 'KoopSalon', 'KS', 'green.50', 'green.700'],
  [OfferType.ZnacnovePojisteniMazda, 'Pojištění Mazda', "PM", "red.50", "red.700"],
  [OfferType.ZnacnovePojisteniSubaru, 'Pojištění Subaru', "PS", "blue.700", "blue.50"],
  [OfferType.ZnackovePojisteniKia, 'Pojištění Kia', "PK", "red.50", "red.700"],
]

export const getOfferTypeName = (type: OfferType) => {
  return type !== undefined ? InsuranceParamsTypes.find(([key]) => key === type)?.[1] : undefined
}

export const getOfferTypeShortName = (type: OfferType) => {
  return type !== undefined ? InsuranceParamsTypes.find(([key]) => key === type)?.[2] : undefined
}

export const getOfferTypeColor = (type: OfferType) => {
  return type !== undefined ? [InsuranceParamsTypes.find(([key]) => key === type)?.[3], InsuranceParamsTypes.find(([key]) => key === type)?.[4]] : undefined
}